module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1520-b5785b6a0f5c0007b9b265cb494e158c.png";